import React from 'react'
import { Navigate } from 'react-router-dom'

const DefaultHomeRedirect = () => <Navigate to="/spend" />

export default DefaultHomeRedirect
